import React, { Suspense } from "react";
import LoadingSpinner from "@/components/shared/LoadingSpinner";
import HeroSection from "@/components/howitworks/sections/HeroSection";
import HowItWorksContent from "@/components/howitworks/HowItWorksContent";
import HowItWorksSEO from "@/components/howitworks/HowItWorksSEO";

const HowItWorks = () => {
  return (
    <div>
      <HowItWorksSEO />

      <Suspense fallback={<LoadingSpinner />}>
        <HeroSection />
        <HowItWorksContent />
      </Suspense>
    </div>
  );
};

export default HowItWorks;
